import React, { useEffect, useState } from 'react';
import './App.css';
import HeroSection from './sections/HeroSection';
import FooterSection from './sections/FooterSection';
import FAQSection from './sections/FAQSection';
import TestimonialsSection from './sections/TestimonialsSection';
import TitleBannerSection from './sections/TitleBannerSection';
import StorySection from './sections/StorySection';
import StorySectionAlt from './sections/StorySectionAlt';
import StorySectionTwo from './sections/StorySectionTwo';
import WaiverModal from './components/WaiverModal';

function App() {
  const [waiverOpen, setWaiverOpen] = useState(false);

  // Listen for waiver open event
  useEffect(() => {
    const onEvt = () => setWaiverOpen(true);
    window.addEventListener('sj-open-waiver', onEvt);
    return () => window.removeEventListener('sj-open-waiver', onEvt);
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)' }}>
      <HeroSection />
      <TitleBannerSection />
      <StorySection />
      <StorySectionAlt />
      <StorySectionTwo />
      <WaiverModal open={waiverOpen} onClose={() => setWaiverOpen(false)} />
      <TestimonialsSection />
      <FAQSection />
      <FooterSection />
    </div>
  );
}

export default App;
